import { render, staticRenderFns } from "./lostinself.vue?vue&type=template&id=6b9cf426&scoped=true&"
import script from "./lostinself.vue?vue&type=script&lang=js&"
export * from "./lostinself.vue?vue&type=script&lang=js&"
import style0 from "./lostinself.vue?vue&type=style&index=0&id=6b9cf426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9cf426",
  null
  
)

export default component.exports